// Schoolplanner (0076_school_plan). Handgeschreven zoals groeiSchool.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/schoolPlan.ts); openapi.contract.test.ts bewaakt elke aanroep.
// Afvinken van huiswerk, oefenen en huiswerktijden gaat via de taken (task-instances/complete).
const id = (v) => encodeURIComponent(v);
export function createSchoolPlanClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const del = (path, body) => t.request('DELETE', path, body);
    const base = '/v1/app/school/plan';
    return {
        get: (memberId) => get(memberId ? `${base}?member_id=${id(memberId)}` : base),
        today: () => get(`${base}/today`),
        addTrack: (memberId, input) => post(`${base}/members/${id(memberId)}/tracks`, input),
        updateTrack: (trackId, input) => patch(`${base}/tracks/${id(trackId)}`, input),
        removeTrack: (trackId, ifVersion) => del(`${base}/tracks/${id(trackId)}`, { if_version: ifVersion }),
        addHomework: (memberId, input) => post(`${base}/members/${id(memberId)}/homework`, input),
        updateHomework: (homeworkId, input) => patch(`${base}/homework/${id(homeworkId)}`, input),
        homeworkDone: (homeworkId, done, ifVersion) => put(`${base}/homework/${id(homeworkId)}/done`, {
            done,
            if_version: ifVersion,
        }),
        removeHomework: (homeworkId, ifVersion) => del(`${base}/homework/${id(homeworkId)}`, { if_version: ifVersion }),
        addSlot: (memberId, input) => post(`${base}/members/${id(memberId)}/slots`, input),
        updateSlot: (slotId, input) => patch(`${base}/slots/${id(slotId)}`, input),
        removeSlot: (slotId, ifVersion) => del(`${base}/slots/${id(slotId)}`, { if_version: ifVersion }),
        addTest: (memberId, input) => post(`${base}/members/${id(memberId)}/tests`, input),
        updateTest: (testId, input) => put(`${base}/tests/${id(testId)}`, input),
        removeTest: (testId, ifVersion) => del(`${base}/tests/${id(testId)}`, { if_version: ifVersion }),
        /** Herinnering voor de beoordeling: uitstellen, een eigen moment of uit (null). */
        reminder: (testId, input) => put(`${base}/tests/${id(testId)}/reminder`, input),
        movePractice: (practiceId, day, ifVersion) => patch(`${base}/practice/${id(practiceId)}`, {
            practice_on: day,
            if_version: ifVersion,
        }),
        practiceDone: (practiceId, done, ifVersion) => put(`${base}/practice/${id(practiceId)}/done`, {
            done,
            if_version: ifVersion,
        }),
        grade: (testId, input) => put(`${base}/tests/${id(testId)}/grade`, input),
        removeGrade: (testId, ifVersion) => del(`${base}/tests/${id(testId)}/grade`, { if_version: ifVersion }),
        clear: (memberId) => del(`${base}/members/${id(memberId)}`),
        /** Download-URL (GET /v1/app/school/plan/members/{id}/export; step-up). */
        exportUrl: (memberId, format) => `${base}/members/${id(memberId)}/export?format=${format}`,
    };
}
//# sourceMappingURL=schoolPlan.js.map